import moment from 'moment';
import sortBy from 'lodash/sortBy';

import {UsersTableActions} from "../const/ActionsConst";

const initialState = {
    table: {
        columns: {
            username: 150,
            createdDate: 100,
            createdBy: 150,
            passwordChanged: 150,
            lockedDate: 100
        },
        rowsCount: 0,
    },
    searchKeyword: '',
    selectedUsers: [],
    users: [],
    cachedUsers: []
};

const normalizeText = (text) => text ? text.toLowerCase().trim() : '';

const filterUsers = (users = [], params) => {
    return users.filter((user) => {
        return Object.values(user).some((value) => {
            return normalizeText(value).includes(normalizeText(params.searchKeyword));
        });
    });
};

const usersTable = (state = initialState, action) => {
    switch (action.type) {
        case UsersTableActions.FILTER_USERS: 
            const { searchKeyword } = action.params;
            const filteredUsers = filterUsers(state.cachedUsers, { searchKeyword });

            return {
                ...state,
                searchKeyword,
                users: sortBy(
                    filteredUsers,
                    (user) => {
                        return !Object.values(user).some((value) => {
                            return normalizeText(value).startsWith(normalizeText(searchKeyword));
                        });
                    }
                ),
                selectedUsers: filteredUsers
                    .filter(({ username }) => state.selectedUsers.includes(username))
                    .map(({ username }) => username)
            };
        case UsersTableActions.USERS_LOADED:
            const normalizedUsers = action.users.map((x) => ({  
                ...x,
                createdDate: moment(x.createdDate).format('MM/DD/YYYY'),
                passwordChangedDate: x.passwordChangedDate ? moment(x.passwordChangedDate).format('MM/DD/YYYY') : '',
                lockedDate: x.lockedDate ? moment(x.lockedDate).format('MM/DD/YYYY') : '',
            }));

            return {
                ...state,
                table: {
                    ...state.table,
                    rowsCount: action.users.length,
                },
                users: filterUsers(normalizedUsers, { searchKeyword: state.searchKeyword }),
                cachedUsers: normalizedUsers,
                selectedUsers: [],
            };
        case UsersTableActions.USER_SELECTED:
            return {
                ...state,
                selectedUsers: [action.username]
            };
        case UsersTableActions.SELECT_MULTIPLE_USERS:
            return {
                ...state,
                selectedUsers: action.selectedUsers
            };    
        case UsersTableActions.CLEAR_SELECTED_USERS:
            return {
                ...state,
                selectedUsers: []
            }; 
        case UsersTableActions.SET_COLUMNS_WIDTH:
            return {
                ...state,
                table: {
                    ...state.table,
                    columns: action.columns
                }
            };
        case UsersTableActions.COLUMN_RESIZED:
            return {
                ...state,
                table: {
                    ...state.table,
                    columns: {
                        ...state.table.columns,
                        [action.id]: action.width
                    }
                }
            };
        default:
            return state;
    }
};

export default usersTable;